import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { config } from "@fortawesome/fontawesome-svg-core";
import { PostHogProvider } from "posthog-js/react";
import { CaptureResult, PostHogConfig } from "posthog-js";
import graphQLClient from "./apollo-client";
import App from "./app";

import "@fortawesome/fontawesome-svg-core/styles.css"; // Import FontAwesome CSS
import "./styles/_globals.scss";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  capture_pageview: false,
  custom_campaign_params: ["via"],
  before_send(event: CaptureResult | null) {
    if (
      event?.event === "$exception" &&
      window.location.hostname === "localhost"
    ) {
      return null;
    }
    return event;
  },
} as Partial<PostHogConfig>;

config.autoAddCss = false; // Prevent FontAwesome from auto-adding CSS

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <ApolloProvider client={graphQLClient}>
        <App />
      </ApolloProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
